import { Currency } from '@/core/currency/interfaces';

const CNY: Currency = {
    name: 'Chinese Yuan',
    demonym: 'Chinese',
    majorSingle: 'Yuan',
    majorPlural: 'Yuan',
    codeNumeric: '156',
    symbol: 'CN¥',
    symbolNative: '¥元',
    minorSingle: 'Fen',
    minorPlural: 'Fen',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'CNY',
    delimiters: {
        thousands: ',',
        decimal: '.'
    }
};

export default CNY;
